import React from 'react'

export default function HomeMessage({homeData}) {
  if (!homeData?.quote) return null;

  return (
    <>
    <section className="message">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-10 col-md-10">
                    <p className="wow animate__animated animate__fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.1s">{homeData?.quote}</p>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
